/**
 *
 * browser's default setTimeout is not reliable when
 * 1. tabs are inactive (Chrome verified)
 * 2. os goes to sleep
 *
 * this service ATTEMPS to negate these situations.
 *
 */
import { Injectable, NgZone } from '@angular/core';
import { Subject, Observable } from 'rxjs';
import { filter, first, map, tap } from 'rxjs/operators';
import { AngularFireDatabase } from '@angular/fire/database';

@Injectable({
  providedIn: 'root'
})
export class TimerService {
  private tickEvent = new Subject();
  public serverTimeOffset: number = 0;
  constructor(public db: AngularFireDatabase, private zone: NgZone) {
    /**
     * setInterval is overriden by Angular to cause a change detection cycle.
     * avoid unnecessary detection cycles by using zone.runOutsideAnguler.
     */
    this.zone.runOutsideAngular(() => {
      setInterval(() => {
        this.tickEvent.next(Date.now());
      }, 1000);
    });
  }
  setTimeout(timeDiff: number): Observable<any> {
    const at = Date.now() + timeDiff;
    return this.tickEvent.pipe(
      filter(cts => cts >= at),
      first()
    );
  }
  fetchServerTimeOffset(): Observable<number> {
    return this.db
      .object('.info/serverTimeOffset')
      .valueChanges()
      .pipe(
        map((offset: number) => (Math.abs(offset) > 1000 ? offset : 0)),
        tap(offset => (this.serverTimeOffset = offset)),
        first()
      ) as Observable<number>;
  }
}
